enum CodeTaskParameterTypeEnum {
    Text = 1,
    Number = 2,
    Decimal = 3,
    Date = 4,
    ItemStatus = 20,
    UserDefinedField = 21,
    ProjectStatus = 22,
    DesignPhase = 23,
    Workflow = 24,
    FunctionalRole = 25,
    AttachmentType = 26,
    GeneratableAttachmentType = 27,
    DocumentOutputType = 28,
    DateUserDefinedField = 29,
    MilestoneDefinition = 30,
}
export default CodeTaskParameterTypeEnum